import { Button, Menu, Toggle, EmptyState } from '@cinesend/ui-kit'
import DataTable from '../data_table'
import { ArrowsClockwise } from '@phosphor-icons/react'
import React from 'react'
import useStore from '../../hooks/use_store'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import ValidatorParams from './validator_params'

const Validators = ({ fieldId, type }) => {
  const { createModel, updateModel } = useStore()
  const queryClient = useQueryClient()
  const queryKey = `validator-fields?type=${type}&field_id=${fieldId}`
  const { isLoading, error, data: validators, refetch } = useQuery([queryKey])

  const formatParameters = (data) => {
    if (!data.parameters || typeof data.parameters != 'object' || Object.keys(data.parameters).length === 0) {
      return ''
    }

    return (
      <ValidatorParams
        key={`${data.name}-${data.id}`}
        name={data.name}
        data={data}
        fieldId={fieldId}
        refreshData={refreshData}
      />
    )
  }

  const refreshData = () => {
    queryClient.invalidateQueries([queryKey])
  }

  const onStatusChange = (item) => {
    createModel.mutate(
      {
        endpoint: 'validator-fields',
        data: {
          validator_id: item.id,
          field_id: fieldId,
          severity: item.severity,
          enabled: item.active,
          parameters: item.parameters,
        },
      },
      {
        onSuccess: () => refreshData(),
      }
    )
  }

  const severityDropdown = (data) => {
    const items =
      validators?.severity_levels?.map((item) => ({
        id: item.value,
        label: item.label,
        onSelect: () => {
          onStatusChange({ ...data, severity: item.value })
        },
      })) || []

    return <Menu trigger={<Button variant='ghost'>{data.severity || 'N/A'}</Button>} items={items} />
  }

  const onValidatorReset = (item) => {
    createModel.mutate(
      {
        endpoint: 'validator-fields/reset',
        data: {
          validator_id: item.id,
          field_id: fieldId,
        },
      },
      {
        onSuccess: () => refreshData(),
      }
    )
  }

  if (!validators?.severity_levels) {
    return <div>Loading...</div>
  }

  const columns = [
    {
      key: 'active',
      header: 'Active',
      render: (data) => (
        <Toggle
          key={data.id}
          text={`${data.name} active`}
          onToggle={() => {
            onStatusChange({ ...data, active: !data.active })
          }}
          pressed={!!data.active}
        />
      ),
    },
    { key: 'validator', header: 'Validator', render: (data) => data.name },
    { key: 'parameters', header: 'Value', render: (data) => formatParameters(data) },
    { key: 'description', header: 'Description', render: (data) => data.description },
    { key: 'severity', header: 'Severity', render: (data) => severityDropdown(data) },
    {
      key: 'reset',
      header: 'Reset',
      width: '50px',
      render: (data) => (
        <Button
          variant='secondary'
          iconOnly
          leadingIcon={<ArrowsClockwise size={20} />}
          onClick={() => onValidatorReset(data)}
        >
          Reset validator
        </Button>
      ),
    },
  ]

  return (
    <div className='pt-5 '>
      <p>Field Validators:</p>
      <DataTable
        caption='Field validators'
        columns={columns}
        rows={validators?.data ?? []}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No validators found!' detail='Create a new validator to begin.' />}
      />
    </div>
  )
}

export default Validators
